import type { MachineRecurringAssignment, ProductionReferenceData } from "./models";
import "./recurring-operator-assignments.css";

type Props = {
  assignments: MachineRecurringAssignment[];
  lines: ProductionReferenceData["lines"];
  cancelTargetId: string | null;
  saving: boolean;
  onRequestCancel: (id: string) => void;
  onDismissCancel: () => void;
  onConfirmCancel: () => void;
};

export function RecurringOperatorAssignments({ assignments, lines, cancelTargetId, saving, onRequestCancel, onDismissCancel, onConfirmCancel }: Props) {
  const active = assignments.filter((item) => item.status === "ACTIVE").sort((a, b) => a.shiftCode.localeCompare(b.shiftCode, "tr") || a.operatorName.localeCompare(b.operatorName, "tr"));
  const target = active.find((item) => item.id === cancelTargetId);
  const lineName = (id: string) => lines.find((line) => line.id === id)?.name ?? "Hat bulunamadı";

  return <section className="recurring-operator-assignments" aria-label="Kalıcı vardiya düzeni">
    <header><h2>Kalıcı vardiya düzeni</h2><small>Her gün aynı hat ve vardiyada geçerlidir. Operatör vardiyaya kendi PIN’iyle girer.</small></header>
    {active.length ? <div className="recurring-operator-table"><table>
      <thead><tr><th scope="col">Hat</th><th scope="col">Vardiya</th><th scope="col">Operatör</th><th scope="col">Görev</th><th scope="col">İşlem</th></tr></thead>
      <tbody>{active.map((item) => <tr key={item.id}>
        <th scope="row">{lineName(item.lineId)}</th><td>{item.shiftCode}</td><td>{item.operatorName}</td><td>{item.assignmentRole === "PRIMARY" ? "Sorumlu" : "Yardımcı"}</td>
        <td><button type="button" disabled={saving} aria-label={`${item.operatorName}, ${item.shiftCode} kalıcı görevlendirmesini kaldır`} onClick={() => onRequestCancel(item.id)}>Görevlendirmeyi kaldır</button></td>
      </tr>)}</tbody>
    </table></div> : <p>Henüz kalıcı düzen yok. Operatör ata bölümünden “Bu vardiyada her gün tekrarla” seçeneğiyle oluşturabilirsiniz.</p>}
    {target ? <form className="recurring-operator-cancel" onSubmit={(event) => { event.preventDefault(); onConfirmCancel(); }}>
      <strong>{target.operatorName} · {lineName(target.lineId)} · {target.shiftCode}</strong>
      <p>Kalıcı görevlendirme kaldırılacak; operatör sonraki günlerde bu düzenle listelenmeyecek. Bu görevlendirmeye bağlı açık oturumu varsa kapanacak. Geçmiş kayıtlar korunur.</p>
      <div><button type="button" disabled={saving} onClick={onDismissCancel}>Vazgeç</button><button type="submit" disabled={saving}>{saving ? "Kaldırılıyor…" : "Kalıcı görevlendirmeyi kaldır"}</button></div>
    </form> : null}
  </section>;
}
